import { render } from "./ArabicTextAndTranscription.vue?vue&type=template&id=3b5ce914&ts=true"
import script from "./ArabicTextAndTranscription.vue?vue&type=script&lang=ts"
export * from "./ArabicTextAndTranscription.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__